import React, { useContext, useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap';
import { Oval } from 'react-loader-spinner'
import { listaEmpleadoContext } from '../../../Admin/superAdmin/ListaEmpleados';
import "../ModalAdmin.scss"
import { useAdmin } from '../../../../context/AdminContext';
import { AreaContext } from '../../../../context/AreaContext';

function ModalEmpleado(props) {

    const { areas, setAreas } = useContext(AreaContext)

    const { 
        user, 
        idEmpresa, 
        idEmpleado,
        setIdEmpleado,
        objEmpleado, 
        setObjEmpleado, 
    } = useContext(listaEmpleadoContext)

    const { 
        fetchArea,
        setErrorArea,
        fetchEmpleadosById, 
        setLoadingEmpleado
    } = useAdmin()

    const [newUser, setNewUser] = useState({
        area: "",
        puesto: "",
        nombre: "",
        mail: ""
    })
    
    const [errors, setErrors] = useState({})
    const [modalErr, setModalErr] = useState(null)

    const [loading, setLoading] = useState(false)

    useEffect(() => {
        fetchArea(user, idEmpresa)
        .then(res => {
            if(res.status !== 0){
                setErrorArea(res.codeError)
            } else {
                setAreas(res.objeto)
            }
        })

        if(objEmpleado){
            const obj = JSON.parse(objEmpleado)
            setNewUser({
                area: obj.fk_area === null ? "" : obj.fk_area.toString(),
                puesto: obj.fk_puesto.toString(),
                nombre: obj.nombre,
                mail: obj.mail
            })
        }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[objEmpleado])

    const handleClose = () => {
        setErrors({})
        setNewUser({
            area: "",
            puesto: "",
            nombre: "",
            mail: ""
        })
        setObjEmpleado(null)
        setIdEmpleado(null)
        setModalErr(null)
        props.onHide()
    }

    const handleChange = (e) => {
        const { name, value } = e.target;
        let updatedUser = {
            ...newUser,
            [name]: value,
        };
        if (name === "puesto" && value === "3") {
            updatedUser.area = "";
        }
        setNewUser(updatedUser);
    }

    const validateForm = (data) => {
        const errors = {}
        if(!data.nombre.trim()) {
            errors.nombre = "Escriba el nombre del empleado."
        }
        if(!data.mail.trim()) {
            errors.mail = "Escriba el mail."
        } else if (!/\S+@\S+\.\S+/.test(data.mail)){
            errors.mail = "El email no es válido."
        }
        if(data.area){
            if(!data.area.trim()) {
                errors.area = "Elige el área."
            }
        }
        if(!data.puesto.trim()) {
            errors.puesto = "Elige el puesto."
        }
        if((data.puesto === "4" || data.puesto === "5") && !data.area.trim()){
            errors.area = "Elige el área."
        }
        return errors
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        const newErrors = validateForm(newUser);
        setErrors(newErrors)
        if(Object.keys(newErrors).length === 0){
            setModalErr(null)
            setLoading(true)
            const obj = {
                user,
                idEmpresa: parseInt(idEmpresa),
                idArea: newUser.area === "" ? null : parseInt(newUser.area),
                fk_puesto: parseInt(newUser.puesto),
                nombre: newUser.nombre,
                mail: newUser.mail
            }
            try {
                const res = await fetch(`${process.env.REACT_APP_API_URL}/apis/user/addUser`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify(obj)
                })
                const data = await res.json()
                const errorCode = data.status ?? data.error
                if(errorCode !== 0){
                    setModalErr(data.codeError || data.errorDetalle)
                } else {
                    props.onHide()
                    setErrors({})
                    setNewUser({
                        area: "",
                        puesto: "",
                        nombre: "",
                        mail: ""
                    })
                    setModalErr(null)
                    // actualizar empleados
                    setLoadingEmpleado(true)
                    fetchEmpleadosById(user, idEmpresa)
                }
            } catch (error) {
                setModalErr("Error: Conexión con backend.")
            } finally {
                setLoading(false)
            }
        } else {
            setModalErr("Completar los campos mencionados.")
        }
    }

    const handleChangeEmpleado = async (e) => {
        e.preventDefault()
        const newErrors = validateForm(newUser);
        setErrors(newErrors)
        if(Object.keys(newErrors).length === 0){
            setModalErr(null)
            setLoading(true)
            const obj = {
                user,
                idUser: idEmpleado,
                fk_area: newUser.area === "" || newUser.puesto === "3" ? null : parseInt(newUser.area),
                fk_puesto: parseInt(newUser.puesto),
                nombre: newUser.nombre,
                mail: newUser.mail
            }
            try {
                const res = await fetch(`${process.env.REACT_APP_API_URL}/apis/user/editUser`, {
                    method: "PUT",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify(obj)
                })
                const data = await res.json()
                if(data.status !== 0){
                    setModalErr(data.codeError)
                } else {
                    props.onHide()
                    setErrors({})
                    setNewUser({
                        area: "",
                        puesto: "",
                        nombre: "",
                        mail: ""
                    })
                    setModalErr(null)
                    setObjEmpleado(null)
                    setIdEmpleado(null)
                    // actualizar empleados
                    setLoadingEmpleado(true)
                    fetchEmpleadosById(user, idEmpresa)
                }
            } catch (error) {
                setModalErr("Error: Conexión con backend.")
            } finally {
                setLoading(false)
            }
        } else {
            setModalErr("Completar los campos mencionados.")
        }
    }

    return (
        <>
            {loading && <div className='loading__modalEmpleado' role='status'>
                    <Oval
                        visible={true}
                        height="80"
                        width="80"
                        color="#fff"
                        ariaLabel="oval-loading"
                        wrapperStyle={{}}
                        wrapperClass=""
                    />
                    <p className='text-white fw-medium'>Loading...</p>
                </div>
            }
            <Modal
                {...props}
                // size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                backdrop="static"
                className='modal__empleado'
                dialogClassName={props.dialogClassName}
            >
                <Modal.Header>
                    <Modal.Title id="contained-modal-title-vcenter" className='d-flex flex-row'>
                        {objEmpleado ? <h3 className='m-0'>Modificar empleado</h3>: <h3 className='m-0'>Agregar empleado</h3>}
                        <button className='btn' onClick={handleClose}><i className="bi bi-x-lg fw-bold"></i></button>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {objEmpleado ? (
                        <form className='form__empleado d-flex flex-column' onSubmit={handleChangeEmpleado}>
                            <div className='mb-2'>
                                <label className='mb-1'>Nombre</label>
                                <input
                                    onChange={handleChange}
                                    type="text" 
                                    id="nombre" 
                                    name="nombre" 
                                    autoFocus
                                    className="form-control form-control-sm col-12"
                                    value={newUser.nombre}
                                />
                                {errors.nombre && <span className='form__error d-flex flex-row align-items-center px-1 my-1'><i className="bi bi-exclamation-circle me-1"></i>{errors.nombre}</span>}
                            </div>
                            <div className='mb-2'>
                                <label className='mb-1'>Correo</label>
                                <input
                                    onChange={handleChange}
                                    type="email" 
                                    id="mail" 
                                    name="mail" 
                                    placeholder="usuario@correo.com.ar" 
                                    className="form-control form-control-sm col-12"
                                    value={newUser.mail}
                                />
                                {errors.mail && <span className='form__error d-flex flex-row align-items-center px-1 my-1'><i className="bi bi-exclamation-circle me-1"></i>{errors.mail}</span>}
                            </div>
                            <div className='row mb-2'>
                                <div className='col-12 col-md-6'>
                                    <label className='mb-1'>Puesto</label>
                                    <select
                                        className="form-select form-select-sm"
                                        id="puesto"
                                        name="puesto"
                                        onChange={handleChange} 
                                        value={newUser.puesto}
                                    >
                                        <option value="">Elija una opción</option>
                                        <option value="3">Gerente</option>
                                        <option value="4">Jefe de Área</option>
                                        <option value="5">Empleado</option>
                                        <option value="6">Aprobador de muestras</option>
                                        <option value="7">Auditor externo</option>
                                    </select>
                                </div>
                                {(newUser.puesto === "4" || newUser.puesto === "5") && <div className='col-12 col-md-6'>
                                    <label className='mb-1'>Área</label>
                                    <select 
                                        className="form-select form-select-sm" 
                                        id="area" 
                                        name="area" 
                                        onChange={handleChange} 
                                        value={newUser.area}
                                    >
                                        <option value="">Elija una opción</option>
                                        {areas.map((a, i) => {
                                            return <option key={i} value={a.id_area.toString()}>{a.nombre_del_Area}</option>
                                        })}
                                    </select>
                                    {errors.area && <span className='form__error d-flex flex-row align-items-center px-1 my-1'><i className="bi bi-exclamation-circle me-1"></i>{errors.area}</span>}
                                </div>}
                            </div>
                            {modalErr !== null && <span className='form__error text-center text-danger my-2'><i className="bi bi-exclamation-circle me-1"></i>{modalErr}</span>}
                            <button 
                                type='submit' 
                                className='mt-2 px-4 btn btn-primary rounded-pill shadow-sm fw-medium align-self-center'
                                disabled={loading}
                            >
                                {loading ? "Enviando..." : "Modificar empleado"}
                            </button>
                        </form>
                    ) : (
                        <form className='form__empleado d-flex flex-column' onSubmit={handleSubmit}>
                            <div className='mb-2'>
                                <label className='mb-1'>Nombre</label>
                                <input
                                    onChange={handleChange}
                                    type="text" 
                                    id="nombre" 
                                    name="nombre" 
                                    autoFocus
                                    className="form-control form-control-sm col-12"
                                    value={newUser.nombre}
                                />
                                {errors.nombre && <span className='form__error d-flex flex-row align-items-center px-1 my-1'><i className="bi bi-exclamation-circle me-1"></i>{errors.nombre}</span>}
                            </div>
                            <div className='mb-2'>
                                <label className='mb-1'>Correo</label>
                                <input
                                    onChange={handleChange}
                                    type="email" 
                                    id="mail" 
                                    name="mail" 
                                    placeholder="usuario@correo.com.ar" 
                                    className="form-control form-control-sm col-12"
                                    value={newUser.mail}
                                />
                                {errors.mail && <span className='form__error d-flex flex-row align-items-center px-1 my-1'><i className="bi bi-exclamation-circle me-1"></i>{errors.mail}</span>}
                            </div>
                            <div className='row mb-2'>
                                <div className='col-12 col-md-6'>
                                    <label className='mb-1'>Puesto</label>
                                    <select
                                        className="form-select form-select-sm"
                                        id="puesto"
                                        name="puesto"
                                        onChange={handleChange} 
                                        value={newUser.puesto}
                                    >
                                        <option value="">Elija una opción</option>
                                        <option value="3">Gerente</option>
                                        <option value="4">Jefe de Área</option>
                                        <option value="5">Empleado</option>
                                        <option value="6">Aprobador de muestras</option>
                                        <option value="7">Auditor externo</option>
                                    </select>
                                </div>
                                {(newUser.puesto === "4" || newUser.puesto === "5") && <div className='col-12 col-md-6'>
                                    <label className='mb-1'>Área</label>
                                    <select 
                                        className="form-select form-select-sm" 
                                        id="area" 
                                        name="area" 
                                        onChange={handleChange} 
                                        value={newUser.area}
                                    >
                                        <option value="">Elija una opción</option>
                                        {areas.map((a, i) => {
                                            return <option key={i} value={a.id_area.toString()}>{a.nombre_del_Area}</option>
                                        })}
                                    </select>
                                    {errors.area && <span className='form__error d-flex flex-row align-items-center px-1 my-1'><i className="bi bi-exclamation-circle me-1"></i>{errors.area}</span>}
                                </div>}
                            </div>
                            {modalErr !== null && <span className='form__error text-center text-danger my-2'><i className="bi bi-exclamation-circle me-1"></i>{modalErr}</span>}
                            <button 
                                type='submit' 
                                className='mt-2 px-4 btn btn-primary rounded-pill shadow-sm fw-medium align-self-center'
                                disabled={loading}
                            >
                                {loading ? "Enviando..." : "Agregar empleado"}
                            </button>
                        </form>
                    )}
                </Modal.Body>
            </Modal>
        </>
    )
}

export default ModalEmpleado